import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
    children?: ReactNode;
    'data-auto'?: string;
}

export const WidgetPlaceholder: FC<Props> = ({ children, ...domAttrs }) => (
    <Container {...domAttrs}>
        <Message>{children}</Message>
    </Container>
);

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    width: 100%;
    box-sizing: border-box;
    background-color: #ffffff;
    border: 1px dashed #cfcfd3;
`;

const Message = styled.span`
    min-width: 1px;
    margin: 0;
    font-family: 'Duda Sans', Roboto, sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    color: #9b9ba2;
    word-break: break-word;
`;
